import { BadgeCheck, Instagram, Mail, MapPin, MessageCircle } from "lucide-react";
import { footerContent, site, waLink } from "@/content/siteContent";
import { scrollToSection } from "@/lib/smoothScroll";

export default function Footer() {
  return (
    <footer id="contato" className="honeycomb bg-coal" data-testid="footer">
      <div className="relative z-10 mx-auto max-w-7xl px-5 py-16 md:px-8 md:py-20">
        <div className="grid gap-12 md:grid-cols-[1.4fr_1fr_1.2fr]">
          <div>
            <img
              src="/images/logo-full.png"
              alt="Sagarelo Refrigeração"
              className="h-28 w-auto rounded-2xl border border-metal object-cover"
              data-testid="footer-logo"
            />
            <p className="mt-6 font-display text-sm font-bold tracking-[0.18em] text-mist">{site.tagline}</p>
            <p className="mt-3 max-w-xs text-sm leading-relaxed text-steel">
              Instalação, manutenção, serviços em altura, placas inverter e PMOC.
            </p>
            <p className="mt-5 inline-flex items-center gap-2 rounded-full border border-metal bg-ink px-4 py-2 text-[0.68rem] font-bold tracking-[0.12em] text-mist" data-testid="footer-crt-badge">
              <BadgeCheck className="h-4 w-4 text-brand" />
              PROFISSIONAIS CREDENCIADOS NO CRT
            </p>
          </div>

          <nav data-testid="footer-menu">
            <p className="microtitle mb-6">NAVEGAÇÃO</p>
            <ul className="space-y-3">
              {footerContent.menu.map((item) => (
                <li key={item.label}>
                  <button
                    onClick={() => (item.href.startsWith("/") ? (window.location.href = item.href) : window.location.pathname !== "/" ? (window.location.href = "/" + item.href) : scrollToSection(item.href))}
                    className="text-sm font-semibold text-mist transition-colors duration-300 hover:text-brand"
                    data-testid={`footer-link-${item.label.toLowerCase()}`}
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <p className="microtitle mb-6">CONTATO</p>
            <ul className="space-y-4">
              <li>
                <a href={waLink()} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-sm font-semibold text-mist transition-colors duration-300 hover:text-brand" data-testid="footer-whatsapp-link">
                  <MessageCircle className="h-4 w-4 text-brand" />
                  WhatsApp {site.whatsappDisplay}
                </a>
              </li>
              <li>
                <a href={site.instagram} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-sm font-semibold text-mist transition-colors duration-300 hover:text-brand" data-testid="footer-instagram-link">
                  <Instagram className="h-4 w-4 text-brand" />
                  {site.instagramHandle}
                </a>
              </li>
              <li>
                <a href={`mailto:${site.email}`} className="flex items-center gap-3 text-sm font-semibold text-mist transition-colors duration-300 hover:text-brand" data-testid="footer-email-link">
                  <Mail className="h-4 w-4 text-brand" />
                  {site.email}
                </a>
              </li>
              <li className="flex items-center gap-3 text-sm font-semibold text-mist" data-testid="footer-region">
                <MapPin className="h-4 w-4 text-brand" />
                {site.regionLong}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-metal pt-7 md:flex-row">
          <p className="text-xs tracking-wide text-steel">
            © 2026 {site.name} {site.suffix} — Todos os direitos reservados.
          </p>
          <span className="h-1.5 w-1.5 rotate-45 bg-brand" />
          <p className="text-xs tracking-[0.18em] text-steel">{site.schedule}</p>
        </div>
      </div>
    </footer>
  );
}
